import { format } from 'date-fns';

type DateRange = { startDate?: string | null; endDate?: string | null };

/**
 * format's and experience date range into a readable format
 */
export function formatDateRange({ startDate, endDate }: DateRange) {
  // NOTE: since by default client side dates will always render in local time we want to show the date based on UTC TZ
  const tzOffset = new Date().getTimezoneOffset() * 60 * 1000;
  const start = startDate ? formatDate(startDate, tzOffset) : '';
  const end = endDate ? formatDate(endDate, tzOffset) : 'Present';
  return startDate ? `${start} - ${end}` : '';
}

function formatDate(date: string, tzOffset: number) {
  return format(new Date(date).getTime() + tzOffset, 'MMM yyyy');
}
